package org.bsvac.bsvac_kmp.ui.subscreens

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import bsvac_kmp.composeapp.generated.resources.Res
import bsvac_kmp.composeapp.generated.resources.error_24px
import org.bsvac.bsvac_kmp.data.BsvacTextStyle
import org.bsvac.bsvac_kmp.data.fakeData.DataSource
import org.bsvac.bsvac_kmp.data.models.AgencyModel
import org.bsvac.bsvac_kmp.data.models.AmbulanceUnitModel
import org.bsvac.bsvac_kmp.data.models.BoroughModel
import org.bsvac.bsvac_kmp.data.models.CrewModel
import org.bsvac.bsvac_kmp.data.models.RadioModel
import org.bsvac.bsvac_kmp.data.models.TourModel
import org.bsvac.bsvac_kmp.ui.models.Choices
import org.bsvac.bsvac_kmp.ui.models.LogonSubScreenModel
import org.bsvac.bsvac_kmp.ui.models.OnSelection
import org.bsvac.bsvac_kmp.ui.models.Selected
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview

@Composable
fun LogonSubScreen(scope: BoxScope, model: LogonSubScreenModel) {
    val bsvacTextStyle = model.bsvacTextStyle
    scope.apply {
        val rowScrollState = rememberScrollState()
        val column1ScrollState = rememberScrollState()
        val column2ScrollState = rememberScrollState()
        val spacerVerticalWeight = 0.06f
        Row(modifier = Modifier.align(Alignment.TopCenter)
            .fillMaxHeight(spacerVerticalWeight)
            .fillMaxWidth()
            .border(width = 1.dp, color = Color.Blue)
        ) {}
        Row(modifier = Modifier.align(Alignment.BottomCenter)
            .fillMaxHeight(spacerVerticalWeight)
            .fillMaxWidth()
            .border(width = 1.dp, color = Color.Blue),
            verticalAlignment = Alignment.CenterVertically
        ) {
            val statusFont = bsvacTextStyle.fontSize
            Text(text = DataSource.LogonStatusMessage(), fontSize = statusFont, color = Color.White )
        }





            Row(modifier = Modifier.align(Alignment.Center)
                .horizontalScroll(rowScrollState).fillMaxHeight(.7f)) {
                Text(
                    modifier = Modifier.fillMaxWidth(),
                    text = DataSource.LogonHeader(),
                    fontSize = bsvacTextStyle.fontSize,
                    color = Color.White
                )
                Column(modifier = Modifier.verticalScroll(column1ScrollState)) {
                    SelectAgency(options = model.choices.agencyOptions, bsvacTextStyle = bsvacTextStyle, onAgencySelected = model.onSelection.onAgencySelected, selected = model.selected.agency)
                    SelectBoroughCoverage(options = model.choices.boroughOptions, bsvacTextStyle = bsvacTextStyle, onBoroughSelected = model.onSelection.onBoroughSelected, selected = model.selected.borough)
                    SelectCrewMember(options = model.choices.crewMemberOptions, crewNumber = 1, bsvacTextStyle = bsvacTextStyle, onCrewMemberSelected = model.onSelection.onCrewMemberSelected, selected = model.selected.crewMember1)
                    SelectCrewMember(options = model.choices.crewMemberOptions, crewNumber = 2, bsvacTextStyle = bsvacTextStyle, onCrewMemberSelected = model.onSelection.onCrewMemberSelected, selected = model.selected.crewMember2)
                    SelectCrewMember(options = model.choices.crewMemberOptions, crewNumber = 3, bsvacTextStyle = bsvacTextStyle, onCrewMemberSelected = model.onSelection.onCrewMemberSelected, selected = model.selected.crewMember3)
                    SelectCrewMember(options = model.choices.crewMemberOptions, crewNumber = 4, bsvacTextStyle = bsvacTextStyle, onCrewMemberSelected = model.onSelection.onCrewMemberSelected, selected = model.selected.crewMember4)
                }
                Column(modifier = Modifier.verticalScroll(column2ScrollState)) {
                    SelectUnit(options = model.choices.unitOptions, bsvacTextStyle = bsvacTextStyle, onUnitSelected = model.onSelection.onAmbulanceUnitSelected, selected = model.selected.unit)
                    SelectTour(options = model.choices.tourOptions, bsvacTextStyle = bsvacTextStyle, onTourSelected = model.onSelection.onTourSelected, selected = model.selected.tour)
                    SelectRadio(options = model.choices.radioOptions, radioNumber = 1, bsvacTextStyle = bsvacTextStyle, onRadioSelected = model.onSelection.onRadioSelected, selected = model.selected.radio1)
                    SelectRadio(radioNumber = 2, bsvacTextStyle = bsvacTextStyle, options = model.choices.radioOptions, onRadioSelected = model.onSelection.onRadioSelected, selected = model.selected.radio2)
                    SelectRadio(radioNumber = 3, bsvacTextStyle = bsvacTextStyle, options = model.choices.radioOptions, onRadioSelected = model.onSelection.onRadioSelected, selected = model.selected.radio3)
                    SelectRadio(radioNumber = 4, bsvacTextStyle = bsvacTextStyle, options = model.choices.radioOptions, onRadioSelected = model.onSelection.onRadioSelected, selected = model.selected.radio4)
                }
            }
    }
}

@Composable
fun SelectTour(bsvacTextStyle: BsvacTextStyle,
               options: List<TourModel>,
               onTourSelected: (TourModel) -> Unit,
               selected: TourModel?
) {
    DropDownPair(
        items = options,
        toStringFunction = { it.displayString },
        label = DataSource.SelectTourLabel(),
        unselectedHint = DataSource.SelectTourHint(),
        bsvacTextStyle = bsvacTextStyle,
        onSelected = onTourSelected,
        selected = selected
    )
}
@Composable
fun SelectBoroughCoverage(
    bsvacTextStyle: BsvacTextStyle,
    options: List<BoroughModel>,
    onBoroughSelected: (BoroughModel) -> Unit,
    selected: BoroughModel?
) {
    DropDownPair(
        items = options,
        toStringFunction = { it.displayString },
        label = DataSource.BoroughCoverageLabel(),
        unselectedHint = DataSource.BoroughCoverageHint(),
        bsvacTextStyle = bsvacTextStyle,
        onSelected = onBoroughSelected,
        selected = selected
    )
}
@Composable
fun SelectRadio(
    radioNumber: Int,
    bsvacTextStyle: BsvacTextStyle,
    options: List<RadioModel>,
    onRadioSelected: (Int, RadioModel) -> Unit,
    selected: RadioModel?,
) {
    DropDownPair(
        items = options,
        toStringFunction = { it.displayString },
        label = DataSource.SelectRadioLabel(radioNumber),
        unselectedHint = DataSource.SelectRadioHint(radioNumber),
        bsvacTextStyle = bsvacTextStyle,
        onSelected = { onRadioSelected(radioNumber, it) },
        selected = selected
    )
}
@Composable
fun SelectCrewMember(
    crewNumber: Int,
    bsvacTextStyle: BsvacTextStyle,
    options: List<CrewModel>,
    onCrewMemberSelected: (Int, CrewModel) -> Unit,
    selected: CrewModel?
) {
    DropDownPair(
        items = options,
        toStringFunction = { it.displayString },
        label = DataSource.SelectCrewLabel(crewNumber),
        unselectedHint = DataSource.SelectCrewMemberHint(crewNumber),
        bsvacTextStyle = bsvacTextStyle,
        onSelected = { onCrewMemberSelected(crewNumber, it) },
        selected = selected
    )
}

@Composable
fun LogonColumnChannel() {
    Box(modifier = Modifier.size(width = 30.dp, height = 0.dp))
}

@Composable
fun SelectUnit(
    bsvacTextStyle: BsvacTextStyle,
    options: List<AmbulanceUnitModel>,
    onUnitSelected: (AmbulanceUnitModel) -> Unit,
    selected: AmbulanceUnitModel?
) {
    DropDownPair(
        items = options,
        toStringFunction = { it.displayString },
        label = DataSource.SelectUnitLabel(),
        unselectedHint = DataSource.SelectUnitHint(),
        bsvacTextStyle = bsvacTextStyle,
        onSelected = onUnitSelected,
        selected = selected
    )
}

@Preview
@Composable
fun PreviewErrorDialog() {
    errorDialog(modifier = Modifier, errorMessage = "A Fatal error has occurred")
}
@Composable
fun errorDialog(modifier: Modifier, errorMessage: String): @Composable BoxScope.() -> Unit {
    return {
        Row(modifier = modifier.align(Alignment.TopEnd)
            .background(Color.White)
            .padding(5.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Image(
                painter = painterResource(Res.drawable.error_24px),
                contentDescription = DataSource.ErrorDialogContentDescription(),
                modifier = Modifier.size(24.dp),
                colorFilter = ColorFilter.tint(Color.Red)
            )
            Text(text = errorMessage,
                color = Color.White,
                modifier = Modifier.padding(start = 5.dp)
            )
        }
    }
}
@Composable
fun SelectAgency(options: List<AgencyModel>,
                 bsvacTextStyle: BsvacTextStyle,
                 onAgencySelected: (AgencyModel) -> Unit,
                 selected: AgencyModel?
) {
    DropDownPair(
        items = options,
        toStringFunction = { it.displayString },
        unselectedHint = DataSource.SelectAgencyHint(),
        label = DataSource.SelectAgencyLabel(),
        bsvacTextStyle = bsvacTextStyle,
        onSelected = { onAgencySelected(it) },
        selected = selected,
    )
}

@Composable
fun <T> DropDownPair(
    items: List<T>,
    toStringFunction: (T) -> String,
    label: String,
    unselectedHint: String,
    bsvacTextStyle: BsvacTextStyle,
    onSelected: (T) -> Unit,
    selected: T?
) {
    Box {
        var expanded by remember { mutableStateOf(false) }

        Row {
            Text(text = label,
                modifier = Modifier.padding(20.dp),
                color = Color.White,
                fontSize = bsvacTextStyle.fontSize
            )

            Box {
                Text(
                    text = if (selected != null) {
                        toStringFunction(selected)
                    } else {
                        unselectedHint
                    },
                    fontSize = bsvacTextStyle.fontSize,
                    color = Color.Black,
                    modifier = Modifier.padding(start = 0.dp,
                        top = 20.dp,
                        bottom = 5.dp,
                        end = 20.dp
                    )
                        .background(Color.White)
                        .clickable(onClick = { expanded = true })
                        .defaultMinSize(30.dp)
                )
                DropdownMenu(
                    modifier = Modifier.background(Color.White),
                    expanded = expanded,
                    onDismissRequest = { expanded = false },
                    ) {
                    items.forEachIndexed { index, option ->
                        DropdownMenuItem(text = { Text(text = toStringFunction(option), fontSize = bsvacTextStyle.fontSize) }, onClick = {
                            onSelected(option)
                            expanded = false
                        })
                    }
                }
            }
        }


    }

}
@Composable
@Preview
fun PreviewDrowDownPair() {
    val items = listOf("A", "B", "C")
    DropDownPair(
        items = items,
        toStringFunction = { it },
        label = "Letters",
        "Choose a letter",
        bsvacTextStyle = BsvacTextStyle(15.sp),
        onSelected = {},
        selected = items[0]
    )
}

@Composable
@Preview
fun PreviewLogonSubScreen() {
    Box(modifier = Modifier.size(800.dp)) {
        LogonSubScreen(this, LogonSubScreenModel(
            bsvacTextStyle = BsvacTextStyle(15.sp),
            choices = Choices(
                agencyOptions = AgencyModel.entries,
                boroughOptions = BoroughModel.entries,
                crewMemberOptions = CrewModel.entries,
                unitOptions = AmbulanceUnitModel.entries,
                tourOptions = TourModel.entries,
                radioOptions = RadioModel.entries,
            ),
            selected = Selected(),
            onSelection = OnSelection(
                onAgencySelected = {},
                onCrewMemberSelected = { _, _ -> },
                onBoroughSelected = {},
                onAmbulanceUnitSelected = {},
                onTourSelected = {},
                onRadioSelected = { _, _ -> },
            ),
        )
        )
    }
}